import type { TFunction } from 'i18next';

import { ApiError } from './api/client.js';

/** A sentence for an API error in the user's language (api-spec §2 codes). */
export function errorMessage(error: unknown, t: TFunction): string {
  if (!(error instanceof ApiError)) return t('errors.INTERNAL');
  if (error.code === 'WEAK_PASSWORD') {
    const reason = (error.problem as { reason?: string }).reason;
    if (reason)
      return t(`errors.weakPassword.${reason}`, { defaultValue: t('errors.WEAK_PASSWORD') });
  }
  // Passwords from a session: a few per 15 minutes per person (SP-A2.176), not "a moment".
  if (error.code === 'RATE_LIMITED' && (error.problem as { reason?: string }).reason === 'password')
    return t('errors.passwordChecks');
  // A plan on invoice beside a checkout of Stripe still being paid (SP-A2.219): the admin's
  // invoice and booking; the customer's Checkout says it in its own words.
  if (
    error.code === 'CONFLICT' &&
    (error.problem as { reason?: string }).reason === 'stripe_pending'
  )
    return t('errors.stripePending');
  // A VAT ID of another country than the address is no "not valid" of the register (SP-A2.79).
  if (
    error.code === 'VAT_ID_INVALID' &&
    (error.problem as { reason?: string }).reason === 'country'
  )
    return t('errors.vatIdCountry');
  return t(`errors.${error.code}`, { defaultValue: t('errors.INTERNAL') });
}
